export enum TicketType {
    MOBILE = 'MOBILE',
    PRINT = 'PRINT',
    UNKNOWN = 'UNKNOWN',
}
